import { cn } from '@/lib/utils'

/* Deterministic tint from the name, so a player keeps the same colour between
 * reloads without storing one. */
const TINTS = [
  'bg-ok-surface text-ok',
  'bg-warn-surface text-warn',
  'bg-err-surface text-err',
  'bg-accent/12 text-accent',
  'bg-bg-hover text-fg-muted',
]

function tintFor(seed: string) {
  let hash = 0
  for (const char of seed) hash = (hash * 31 + char.charCodeAt(0)) >>> 0
  return TINTS[hash % TINTS.length]
}

export function initialsOf(name: string) {
  const parts = name.replace(/([a-z])([A-Z])/g, '$1 $2').split(/[\s_-]+/)
  return (parts[0]?.[0] ?? '') + (parts[1]?.[0] ?? parts[0]?.[1] ?? '')
}

interface AvatarCellProps {
  name: string
  /** Circle for people, rounded square for things. */
  shape?: 'circle' | 'square'
  className?: string
}

export function AvatarCell({ name, shape = 'circle', className }: AvatarCellProps) {
  return (
    <span
      aria-hidden
      className={cn(
        'text-2xs grid shrink-0 place-items-center font-semibold uppercase',
        shape === 'circle' ? 'size-6.5 rounded-full' : 'size-4.5 rounded-sm',
        tintFor(name),
        className,
      )}
    >
      {initialsOf(name)}
    </span>
  )
}
